import type { FileData, FilesMap } from '@/client/lib/filesContext';

/**
 * Normalize the `files` slice of LangGraph agent state into `FilesMap`.
 *
 * Handles both deepagents shapes so stale checkpointed threads don't crash
 * the UI after a dependency bump:
 * - ≤0.4: `{ content: string[], created_at, modified_at }`
 * - ≥0.5: `{ content: string, encoding?: string, created_at?, modified_at? }`
 *
 * Unknown or malformed entries are dropped rather than surfaced.
 */
export function normalizeFiles(raw: unknown): FilesMap {
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return {};
  const out: FilesMap = {};
  for (const [path, entry] of Object.entries(raw as Record<string, unknown>)) {
    if (!entry || typeof entry !== 'object' || Array.isArray(entry)) continue;
    const e = entry as Record<string, unknown>;
    const rawContent = e.content;
    const content = Array.isArray(rawContent)
      ? rawContent.join('\n')
      : typeof rawContent === 'string'
        ? rawContent
        : '';
    out[path] = {
      ...(e as object),
      content,
      created_at: typeof e.created_at === 'string' ? e.created_at : '',
      modified_at: typeof e.modified_at === 'string' ? e.modified_at : '',
    } as FileData;
  }
  return out;
}
